<template>
  <div>
    <div>
      <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">
        <div class="row">
          <!--Created At Filter --->
          <div class="col-12 col-md-4" v-if="filtersOptions.includes('created_at')">
            <label class="form-label">{{ $t('statistics.daterange_created_at') }}</label>
            <RangeDatePicker
              id="date-filter-picker"
              v-model="filters.date"
              class="col-12 datesFilter"
              :placeholder="$t('optometry.leads.date_range')"/>
          </div>
          <div class="col-12 col-md-4" v-if="filtersOptions.includes('client')">
            <div>
              <label class="form-label">{{$t('iframe.table_headings.client')}}:</label>
              <multiselect
                v-model="filters.client"
                :options="clientOptions"
                track-by="id"
                label="name"
                :custom-label="formatedEntityLabel"
                select-label=""
                selected-label=""
                deselect-label=""
                :placeholder="$t('iframe.table_headings.client')"
                :allow-empty="true"
                :multiple="false"
                :searchable="true"
                :disabled="clientOptions.length <= 1 || isLoading">
                <template slot="clear">
                <span class="multiselect__clear" v-if="filters.client"
                      @mousedown.prevent.stop="clearClientsMultiselect"></span>
                </template>
              </multiselect>
            </div>
          </div>
        </div>

        <!----->
      </div>
      <v-server-table
        :id="parentRef"
        :ref="parentRef"
        :name="parentRef"
        :columns="columns"
        :options="tableOptions"
        @limit="this.selectedProjects = {}"
        @filter="onFilterUpdate"
        @loading="isLoading = true"
        @loaded="onLoaded"
        @row-click="handleFlowClicked"
        @pagination="onPagination">

        <span slot="beforeFilter">
        <!--<span>
          <va-popover
            v-if="selectedProjectsHashes.length > 0"
            placement="left"
            :message="$t('iframe.actions.clone')">
            <span class="icon fa fa-copy clickable" @click.prevent="onClickClone()"></span>
          </va-popover>
        </span>-->
          <span>
          <va-popover
            v-if="selectedProjectsHashes.length > 0"
            placement="left"
            :message="$t('iframe.actions.delete')">
            <span class="icon fa fa-trash-o clickable" @click.prevent="onClickDelete()"></span>
          </va-popover>
        </span>
        <!--<span>
          <va-popover
            v-if="selectedProjectsHashes.length > 0"
            placement="left"
            :message="$t('iframe.actions.lock')">
            <span class="icon fa fa-lock clickable" @click.prevent="onClickLock()"></span>
          </va-popover>
        </span>-->
      </span>

        <span slot="h__selectProject" v-if="showProjectSelection">
          <span class="round">
            <input class="selectProjectCheckbox" type="checkbox" id="checkboxSelectAllProjects"
                   :checked="selectAllProjects" @click="selectAllProjects = !selectAllProjects">
            <label class="selectProjectCheckbox" for="checkboxSelectAllProjects"></label>
          </span>
        </span>


        <span slot="created_at" slot-scope="props">
          {{ props.row.created_at | localTime('YYYY-MM-DD HH:mm') }}
        </span>
        <span slot="client" slot-scope="props">
            {{ handleClientName(props.row) }}
        </span>

        <span slot="actions" slot-scope="props" class="w-100 d-flex justify-content-center">
         <!-- <va-popover :message="$t('iframe.actions.clone')" placement="top">
            <i class="report-action-icon fa fa-copy p-2 clickable"
               @click.prevent.stop="onClickClone(props.row)"></i>
          </va-popover>-->
          <va-popover :message="$t('iframe.actions.delete')" placement="top">
            <i class="report-action-icon fa fa-trash-o p-2 clickable"
               @click.prevent.stop="onClickDelete(props.row)"></i>
          </va-popover>
         <!-- <va-popover :message="$t('iframe.actions.lock')" placement="top">
            <i class="report-action-icon fa fa-lock p-2 clickable"
               @click.prevent.stop="onClickLock(props.row)"></i>
          </va-popover>-->
        </span>

        <span slot="lang" slot-scope="props">
          {{ props.row.lang.toUpperCase() || "N/A" }}
        </span>

        <span slot="country" slot-scope="props">
          {{ props.row.country.toUpperCase() || "N/A" }}
        </span>

        <span slot="url" slot-scope="props">
          {{ `https://iframe.${envType}.evollu.com?hash=${props.row.hash}` }}
        </span>

        <span slot="selectProject" slot-scope="props">
        <span class="round">
          <!--<input class="selectProjectCheckbox" type="checkbox" :id="`checkbox${props.row.id}`"
                 :checked="selectedProjects[props.row.id]" @click="handleProjectSelected(props.row)">-->
          <input class="selectProjectCheckbox" type="checkbox" :id="`checkbox${props.row.hash}`"
                 :checked="getProjectSelectedState(props.row)" @click="handleProjectSelected(props.row)">
          <label class="selectProjectCheckbox" :for="`checkbox${props.row.hash}`"></label>
        </span>

      </span>


      </v-server-table>
    </div>
    <ConfirmationModal v-if="showDeleteConfirmationModal"
                       :title="confirmationModalTitle"
                       :body="confirmationModalBody"
                       okClass="btn-danger"
                       @modal-confirmed="confirmDelete"
                       @modal-canceled="cancelDelete"
    >
    </ConfirmationModal>

    <ConfirmationModal v-if="showCloningConfirmationModal"
                       :title="cloningConfirmationModalTitle"
                       :body="cloningConfirmationModalBody"
                       okClass="btn-danger"
                       @modal-confirmed="showCloneModeSelectionModal"
                       @modal-canceled="cancelClone"
    >
    </ConfirmationModal>
    <ConfirmationModal v-if="showLockConfirmationModal"
                       :title="lockConfirmationModalTitle"
                       :body="lockConfirmationModalBody"
                       okClass="btn-danger"
                       @modal-confirmed="confirmLock"
                       @modal-canceled="cancelLock"/>

    <CloneModeSelectionModal v-if="showCloningModeSelectionModal"
    @confirm="confirmClone"
    @cancel="cancelClone">

    </CloneModeSelectionModal>

  </div>
</template>

<script>

import RangeDatePicker from "@/components/common/RangeDatePicker";
import TableQueryMixin from "@/mixins/TableQueryMixin";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";
import ConfirmationModal from "@/components/common/ConfirmationModal";
import {IframeService} from "@/api/IframeService";
import CloneModeSelectionModal from "@/components/iframe/CloneModeSelectionModal";
import MultiselectLabelFormatter from "@/mixins/MultiselectLabelFormatter.vue";
import Multiselect from 'vue-multiselect'
import LocalStorageHelper from "@/local-storage/LocalStorageHelper";
import { TABLE_IFRAME_PROJECT_BUILDER, TABLE_IFRAME_PROJECTS_STATISTICS } from '@/local-storage/LocalStorageKeys';

export default {
  components: {CloneModeSelectionModal, ConfirmationModal, LoadingPlaceholder, RangeDatePicker, Multiselect},
  mixins: [
    TableQueryMixin, MultiselectLabelFormatter
  ],
  props: {
    showFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    querySearch: {
      type: String,
      required: false,
      default: null
    },
    customQueries: {
      type: Object,
      required: false,
      default: null
    },
    component: {
      type: Object,
      required: true
    },
    showProjectSelection: {
      type: Boolean,
      required: false,
      default: true
    },
    filtersOptions: {
      type: Array,
      required: false,
      default: ['created_at']
    },
    clientOptions: {
      type: Array,
      required: false,
      default: () => []
    },
    parentRef: {
      type: String,
      required: false,
      default: 'iframeProjectsCPTOTable'
    }
  },
  mounted: async function() {
    let dropdownList = this.$el.getElementsByClassName('VueTables__columns-dropdown')[0].lastElementChild
    dropdownList.removeChild(dropdownList.childNodes[0])
    await this.loadLocalStorage()

    if(this.clientOptions && this.clientOptions.length === 1) {
      this.filters.client = this.clientOptions[0]
    }
  },
  data: function () {
    return {
      filters: {
        client: null,
        querySearch: '',
        date: {
          start: this.moment().subtract(1, 'months').format('YYYY-MM-DD'),
          end: this.moment().format('YYYY-MM-DD'),
        }
      },
      isLoading: false,
      queryUrl: `${this.$store.state.iframe_server}v1/test-flow`,
      //queryUrl: 'https://621e4716849220b1fc95200d.mockapi.io/flows',
      tableOptions: {
        orderBy: {
          column: 'created_at',
          ascending: false
        },
        saveState: true,
        storage: 'local',
        filterable: ['created_at'],
        sortable: ['created_at'],
        customFilters: ['start', 'end', 'client'],
        columnsClasses: {
          created_at: 'createdAtClass',
          actions: 'w-100 d-flex justify-content-center'
        },
        headings: {
          created_at: this.$t('iframe.table_headings.created_at'),
          name: this.$t('iframe.table_headings.project_name'),
          client: this.$t('iframe.table_headings.client'),
          url: this.$t('iframe.table_headings.url'),
          lang: this.$t('iframe.table_headings.lang'),
          country: this.$t('iframe.table_headings.country'),
          actions: this.$t('iframe.table_headings.actions')
        }
      },
      selectedFlowForDeletion: null,
      selectedFlow: null,
      selectedProjects: {},
      selectAllProjects: false,
      selectedProjectsHashes: {},
      showDeleteConfirmationModal: false,
      selectedFlowForCloning: null,
      selectedFlowForLock: null,
      showCloningConfirmationModal: false,
      selectedCloningMode: null,
      showCloningModeSelectionModal: false,
      showLockConfirmationModal: false,
    }
  },
  methods: {
    clearClientsMultiselect: function () {
      this.filters.client = null
    },
    emitActiveFilters: function () {
      let count = 0
      if (this.filters.client) {
        count += 1
      }
      if (this.filters.date && (this.filters.date.start || this.filters.date.end)) {
        count += 1
      }
      this.$emit('filters-updated', count)
    },
    getProjectSelectedState: function(row) {
      return this.selectedProjects[row.hash]
    },
    handleProjectSelected: function (project) {
      this.selectedProjects[project.hash] = !this.selectedProjects[project.hash]
      // this.$emit('projectsSelected', this.getSelectedProjectsHashes())
      this.selectedProjectsHashes = this.getSelectedProjectsHashes()
    },
    getSelectedProjectsHashes: function () {
      const keys = Object.keys(this.selectedProjects)
      let selectedProjectsHashes = keys.filter(key => this.selectedProjects[key] === true)

      return selectedProjectsHashes
    },
    onPagination: function () {
      this.selectAllProjects = false
      this.selectedProjects = {}
    },
    onLoaded: function () {
      this.selectAllProjects = false
      this.selectedProjects = {}
      const projects = this.getData()
      for (const proj of projects) {
        this.selectedProjects[proj.hash] = false
      }
      this.isLoading = false
    },
    getData: function () {
      return this.$refs[this.parentRef].data
    },
    onLoading: function () {
    },
    refresh: function () {
      this.$refs[this.parentRef].refresh()
    },
    deleteFlow(flow) {
      this.selectedFlowForDeletion = flow
    },
    onClickClone: function (project = null) {
      if (project) {
        this.selectedFlowForCloning = project
      }
      this.showCloningConfirmationModal = true
    },
    onClickLock: function (project = null) {
      if (project) {
        this.selectedFlowForLock = project
      }
      this.showLockConfirmationModal = true
    },
    onClickDelete: function (project = null) {
      if (project) {
        this.selectedFlowForDeletion = project
      }
      this.showDeleteConfirmationModal = true
    },
    confirmDelete: function () {
      const multiple = this.selectedFlowForDeletion === null
      let hashes = multiple ? this.getSelectedProjectsHashes() : this.selectedFlowForDeletion.hash

      IframeService.deleteFlow(hashes)
        .then(res => {
          setTimeout(() => {
            if (multiple) {
              this.showToast(this.$t('iframe.flows.multiple_deleted', {nr: hashes.length}), this.$store.state.successToastOptions)
            } else {
              this.showToast(this.$t('iframe.flows.deleted'), this.$store.state.successToastOptions)
            }
            this.refresh()
          }, 500)
        })
        .catch(errors => {
          console.log(errors)
          this.showToast(this.$t('reports.reports.messages.something_went_wrong'), this.$store.state.errorToastOptions)
        })
        .finally(() => {
          this.resetAfterAction()
        })

    },
    showCloneModeSelectionModal: function () {
      this.showCloningConfirmationModal = false
      setTimeout(() => {
        this.showCloningModeSelectionModal = true
      }, 250)

    },
    confirmClone: function (selectedCloningMode) {
      const multiple = this.selectedFlowForCloning === null
      let hashes = multiple ? this.getSelectedProjectsHashes() : this.selectedFlowForCloning.hash
      if (!selectedCloningMode.label) {
        console.log("No cloning mode choosen")
        this.showToast(this.$t('reports.reports.messages.something_went_wrong'), this.$store.state.errorToastOptions)
        return
      }

      IframeService.cloneFlow(selectedCloningMode.label.toLowerCase(), hashes).then(res => {
        setTimeout(() => {
          if (multiple) {
            this.showToast(this.$t('iframe.flows.multiple_cloned', {nr: hashes.length}), this.$store.state.successToastOptions)
          } else {
            this.showToast(this.$t('iframe.flows.cloned'), this.$store.state.successToastOptions)
          }
          this.refresh()
        }, 500)
      }).catch(err => {
        console.log(err)
        this.showToast(this.$t('reports.reports.messages.something_went_wrong'), this.$store.state.errorToastOptions)
      })
        .finally(() => {
          this.resetAfterAction()
        })
    },
    resetAfterAction: function () {
      this.showDeleteConfirmationModal = false
      this.selectAllProjects = false
      this.selectedProjects = {}
      const flows = this.getData()
      for (const flow of flows) {
        this.selectedProjects[flow.hash] = false
      }
      this.selectedFlowForDeletion = null
      this.selectedFlowForCloning = null
      this.selectedCloningMode = null
      this.selectedFlowForLock = null
      this.selectedProjectsHashes = this.getSelectedProjectsHashes()
      this.showLockConfirmationModal = false
    },
    cancelDelete: function () {
      this.showDeleteConfirmationModal = false
      this.selectedFlowForDeletion = null
    },
    cancelClone: function () {
      this.showCloningConfirmationModal = false
      this.showCloningModeSelectionModal = false
      this.selectedFlowForCloning = null
    },
    confirmLock: function () {
      const multiple = this.selectedFlowForLock === null
      let hashes = multiple ? this.getSelectedProjectsHashes() : this.selectedFlowForLock.hash

      IframeService.lockFlow(true, hashes).then(res => {
        setTimeout(() => {
          if (multiple) {
            this.showToast(this.$t('iframe.flows.multiple_locked', {nr: hashes.length}), this.$store.state.successToastOptions)
          } else {
            this.showToast(this.$t('iframe.flows.locked'), this.$store.state.successToastOptions)
          }
          this.refresh()
        }, 500)
      }).catch(err => {
        console.log(err)
        this.showToast(this.$t('reports.reports.messages.something_went_wrong'), this.$store.state.errorToastOptions)
      })
        .finally(() => {
          this.resetAfterAction()
        })
    },
    cancelLock: function () {
      this.showLockConfirmationModal = false
      this.selectedFlowForLock = null
    },
    handleClientName: function (flow) {
      let entity = this.entities.filter(entity => entity.id === parseInt(flow.client_id))[0]
      return entity ? entity.name : 'N/A'
    },
    handleFlowClicked: function ({event, row}) {
      if (event.srcElement.className === "selectProjectCheckbox") {
        event.stopPropagation()
      } else {
        let selectedFlow = row
        const entity = this.entities.filter(entity => entity.id === parseInt(row.client_id))[0]
        selectedFlow.client = entity ? entity : null
        this.$emit('flowClicked', selectedFlow)
      }
    },
    loadLocalStorage: function () {
      return new Promise(resolve => {
        let state = this.parentRef === 'iframeProjectsStatisticsTable' ? LocalStorageHelper.get(TABLE_IFRAME_PROJECTS_STATISTICS) : LocalStorageHelper.get(TABLE_IFRAME_PROJECT_BUILDER)
        let filters = {
          client: null,
          querySearch: '',
          date: {
            start: '',
            end: '',
          }
        }
        if (state !== null) {
          if (state.customQueries.hasOwnProperty('querySearch') && state.customQueries.querySearch.trim() !== '') {
            this.filters.querySearch = state.querySearch
          }

          if (state.customQueries.hasOwnProperty('client') && state.customQueries.client) {
            filters.client = this.clientOptions.find(elem => elem.id === state.customQueries.client)
          }
          if (state.customQueries.hasOwnProperty('start') && state.customQueries.start.trim() !== '') {
            filters.date.start = state.customQueries.start
          }
          if (state.customQueries.hasOwnProperty('end') && state.customQueries.end.trim() !== '') {
            filters.date.end = state.customQueries.end
          }
        }
        this.filters = { ...this.filters, ...filters }

        this.hasLoadedLocalStorage = true
        resolve()
      })
    },
  },
  computed: {
    columns: function () {
      return this.showProjectSelection ? ['selectProject', 'created_at', 'name', 'client', 'url', 'lang', 'country', 'actions'] : ['created_at', 'name', 'client', 'url', 'lang', 'country']
    },
    envType: function () {
      return process.env.VUE_APP_ENVIRONMENT
    },
    confirmationModalTitle: function () {
      return this.selectedFlowForDeletion !== null ? this.$t('iframe.titles.delete') : this.$t('iframe.titles.delete_multiple_projects')
    },
    confirmationModalBody: function () {
      return this.selectedFlowForDeletion !== null
        ? this.$t('iframe.titles.delete_modal_body', {name: this.selectedFlowForDeletion.name})
        : this.$t('iframe.titles.delete_multiple_projects_modal_body', {nr: this.getSelectedProjectsHashes().length})
    },
    cloningConfirmationModalTitle: function () {
      return this.selectedFlowForCloning !== null ? this.$t('iframe.titles.clone') : this.$t('iframe.titles.clone_multiple_projects')
    },
    cloningConfirmationModalBody: function () {
      return this.selectedFlowForCloning !== null
        ? this.$t('iframe.titles.clone_modal_body', {name: this.selectedFlowForCloning.name})
        : this.$t('iframe.titles.clone_multiple_projects_modal_body', {nr: this.getSelectedProjectsHashes().length})
    },
    lockConfirmationModalTitle: function () {
      return this.selectedFlowForLock !== null ? this.$t('iframe.titles.lock_project') : this.$t('iframe.titles.lock_multiple_projects')
    },
    lockConfirmationModalBody: function () {
      return this.selectedFlowForLock !== null
        ? this.$t('iframe.titles.lock_project_modal_body', {name: this.selectedFlowForLock.name})
        : this.$t('iframe.titles.lock_multiple_projects_modal_body', {nr: this.getSelectedProjectsHashes()})
    },
    entities: function () {
      // let iframeService = this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
      let iframeService = this.$store.state.services.find(service => service.slug === "iframe") || null
      if (iframeService) {
        return iframeService.entities
      }
      return null
    },
  },
  watch: {
    selectAllProjects: function (value) {
      const keys = Object.keys(this.selectedProjects)
      for (const key of keys) {
        this.selectedProjects[key] = value
      }
      //this.$emit('projectsSelected', this.getSelectedProjectsHashes())
      this.selectedProjectsHashes = this.getSelectedProjectsHashes()
    },
    customQueries: {
      handler: function (value) {
        if (value) {
          if (value.start && value.start !== '') {
            this.filters.date.start = value.start
          }
          if (value.end && value.end !== '') {
            this.filters.date.end = value.end
          }
        }
      },
      immediate: true
    },
    querySearch: {
      handler: function (value) {
        this.filters.querySearch = value || ''
      },
      immediate: true
    },
    'filters.querySearch': function (value) {
      this.$refs[this.parentRef].setFilter(value)
    },
    'filters.date': function (value) {
      if (!this.$refs[this.parentRef]) {
        return
      }
      this.$refs[this.parentRef].customQueries.start = value.start || ''
      this.emitTableFilter(`vue-tables.${this.parentRef}.filter::end`, value.end || '')
      this.emitActiveFilters()
    },
    'filters.client': function (value) {
      const clientId = value && value.id != null ? String(value.id) : ''
      if (this.$refs[this.parentRef]) {
        // Set directly (same pattern as date.start) so the next request always includes client
        this.$refs[this.parentRef].customQueries.client = clientId
      }
      this.emitTableFilter(`vue-tables.${this.parentRef}.filter::client`, clientId)
      this.emitActiveFilters()
    },
  }
}
</script>

<style>
.selectBlockClass {
  width: 50px;
}

.createdAtClass {
  width: 300px;
}

#iframeProjectsTable .VueTables__search {
  justify-content: space-between;
  float: none !important;
}

.table-hover tbody tr:hover {
  background: rgba(41, 196, 170, 0.5) !important;
}
</style>
<style scoped>

.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 1.375rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 1.375rem;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 5px;
  opacity: 0;
  position: absolute;
  top: 6px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #29c4a9;
  border-color: #29c4a9;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

</style>
<style>
.table-hover tbody tr:hover {
  background: rgba(41, 196, 170, 0.5) !important;
}
</style>
